import { createReducer } from '@reduxjs/toolkit';
import keyBy from 'lodash/keyBy';
import * as actions from '../actions';
import { NotificationsProxiesState } from '../types';

export const proxiesInitialState: NotificationsProxiesState = {
  isFetching: false,
  error: null,
  data: {}
};

const notificationsPreferencesReducer = createReducer(proxiesInitialState, {
  [actions.GET_NOTIFICATIONS_PROXIES]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_NOTIFICATIONS_PROXIES_SUCCESS]: (state, action) => {
    if (state) state.isFetching = false;
    state.data = keyBy(action.payload.data, 'patientId');
  },
  [actions.GET_NOTIFICATIONS_PROXIES_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = {};
    state.error = action.error;
  }
});

export default notificationsPreferencesReducer;
